<!-- eslint-disable vue/no-unused-components -->
<template>
	<b-card no-body>
		<b-row class="d-flex align-items-start">
			<!-- LEFT SECTION -->
			<b-col cols="auto" class="p-3">
				<div class="d-flex align-items-center">
					<div class="p-0 mx-2">
						<el-input placeholder="Search by text" v-model="filters.search_txt" @change="getListing(true)"> <i slot="prefix"
								class="el-input__icon el-icon-search"></i>
						</el-input>
					</div>
				</div>
			</b-col>

			<!-- RIGHT SECTION -->
			<b-col cols="auto" class="ml-auto p-3 mx-2">
				<b-row class="d-flex align-items-center">
					<b-col cols="auto">
						<b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
					</b-col>
				</b-row>
			</b-col>
		</b-row>

		<div class="table-listings">
			<el-table :data="tableData" style="width: 100%" @selection-change="selectionChange" class="mt-4"
				v-loading="is_loading">
				<el-table-column type="selection" width="45"></el-table-column>

				<el-table-column label="Status Name" sortable min-width="150">
					<template slot-scope="scope">
						<p class="top-line text-primary">{{ scope.row.name }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Status Group" sortable min-width="150">

					<template slot-scope="scope">
						<p>{{ scope.row.group_name }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Main Status" sortable min-width="150">

					<template slot-scope="scope">
						<p class="top-line text-primary">{{ scope.row.main_status || '-' }}</p>
					</template>
				</el-table-column>

				<el-table-column label="TAT Day" sortable min-width="150">

					<template slot-scope="scope">
						<p :class="{ 'text-danger': scope.row.stop_tat }">{{ scope.row.tat_day }} days</p>
					</template>
				</el-table-column>

				<el-table-column label="Created By" sortable min-width="150">

					<template slot-scope="scope">
						<p>{{ scope.row.created_by || '-' }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Date Created" sortable min-width="150">

					<template slot-scope="scope">
						<p>{{ scope.row.created_at | dateFormatString }}</p>
					</template>
				</el-table-column>

				<el-table-column width="55" fixed="right">
					<template slot-scope="scope">
						<el-dropdown :tabindex="scope.row.id" class="py-2">
							<b class="el-dropdown-link">
								<b-icon icon="three-dots-vertical">
								</b-icon>
							</b>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="openModal(scope.row)">
									Edit
								</el-dropdown-item>
								<el-dropdown-item @click.native="deleteItem(scope.row.id)">
									Delete
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
			<div class="">
				<p class="card-category">
					Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
					<span v-if="selectedRows.length">
						&nbsp; &nbsp; {{ selectedRows.length }} rows selected
					</span>
				</p>
			</div>
			<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
				:total="pagination.total" @change="paginationChanged($event)">
			</base-pagination>
		</div>
		<CaseStatusForm ref="modal_case_status_form" :module="module"  @closeModal="closeModal"  />
	</b-card>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button, Switch } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import CaseStatusForm from '@/views/AllSettings/StatusPages/CaseStatus/CaseStatusForm'
import { cloneDeep } from 'lodash'
import { swal } from '@/assets/js/httpImports.js';
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';

export default {
	mixins: [clientPaginationMixin],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BasePagination,
    CaseStatusForm,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Switch.name]: Switch,
  },
  data() {
    return {
			module: 'case',
      is_loading: false,
      currentPage: 1,
      mode: 'listing',
			selectedRows: [],
      searchText: '',
      TableColumn: [{
				type: 'selection'
      }],
			tableData: [],
			parentData: [],
			pagination: {
				perPageOptions: [5, 10, 25, 50, 100, 500]
			},
			filters:{
				search_txt:''
			},
			readOnlyItems:[
				{
					module: 'disbursement',
					names: ['Pending Disbursement','Partial Disbursement','Full Disbursement']
				}
			]
    }
  },
  mounted() {
  },
  computed: {
    readOnlyItem(){
			let item = this.readOnlyItems.find(itm => itm.module == this.module);
			return _gHlp.getValue(item,'names',[]);
		}
  },
  created() {
    this.initComponent();
  },
  methods: {
    ...mapActions(useCommonStore, ['deleteStatus', 'getStatusList']),
		initComponent(){
			this.getListing(true);
			this.getParentListing();
		},
		getFilters(){
			let filtered = {};
			let obj = this.filters;
			obj['module'] = this.module
			Object.keys(obj).forEach(key => {
					if (!_gHlp.isEmpty(obj[key])) {
							filtered[key] = obj[key];
					}
			});
			return filtered;
		},
		setFilter(obj){
			this.filters = { ...this.filters, ...obj }
			this.getListing(true)
		},
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    paginationChanged(page) {
      this.pagination.currentPage = page
			this.getListing();
    },
		getListing(resetPage=false) {
			this.is_loading = true
			const params = {
				search: this.getFilters(),
				paginate: this.pagination.perPage,
				page: (resetPage) ? 1 : this.pagination.currentPage
			};
      this.getStatusList(params)
			.then(resp => {
        this.tableData = resp.data;
				this.pagination = resp.pagination;
				this.is_loading = false
      })
			.catch((err)=>{
				this.is_loading = false
			})
    },
		getParentListing() {
			this.is_loading = true
			const params = {
				search: {
					module: this.module,
					parent_id: 'is_null'
				},
				paginate: 'no_paginate'
			};
      this.getStatusList(params)
			.then(resp => {
        this.parentsData = resp.data;
			})
			.catch((err)=>{
				this.is_loading = false
			})
    },
    deleteItem(id) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
					this.is_loading = true
          this.deleteStatus(id).then(resp => {
            this.getListing(true);
						this.getParentListing();
            _gNotif.notifySuccess('<b>Status: </b> - Successfully Deleted.')
						this.is_loading = false
					}).catch((err)=>{
						this.is_loading = false
					})
        }
      })
    },
		openModal(item = null) {
			this.$refs.modal_case_status_form.show(cloneDeep(item),this.parentsData)
		},
    closeModal(refresh=false) {
			if(refresh){
      	this.getListing(true);
      	this.getParentListing();
			}
    },
  }
}
</script>